<template>
  <div class="accept-cookies">
    <p class="accept-cookies__text">
      Our site uses cookies to personalize content and make our site easier
      for you to use.
    </p>
    <div class="accept-cookies__buttons">
      <UnzipButton
          class="accept-cookies__btn"
          :height="null"
          :width="null"
          @click="$store.commit('cookiesAccepted/setStatus', isAccepted)"
      >
        Accept
      </UnzipButton>
      <UnzipButton
          class="accept-cookies__btn"
          :height="null"
          :width="null"
          type="gray"
          :outlined="true"
          @click="$store.commit('cookiesAccepted/setStatus', isRejected)"
      >
        Reject
      </UnzipButton>
    </div>
  </div>
</template>

<script>
import { STATUS_ACCEPTED, STATUS_REJECTED } from "@/constants/cookies-accepted";

export default {
  data() {
    return {
      isAccepted: STATUS_ACCEPTED,
      isRejected: STATUS_REJECTED
    }
  }
}
</script>

<style lang="scss" scoped>
.accept-cookies {
  background: var(--color-grey-270);
  border-radius: 0.625rem;
  box-shadow: 0 0.25rem 3.125rem 0 rgba(255, 255, 255, 0.4);

  display: flex;
  gap: 1.5rem;
  flex-wrap: nowrap;
  flex-direction: row;

  position: fixed;
  bottom: 0.75rem;
  left: 50%;
  transform: translateX(-50%);

  max-width: 45rem;
  width: calc(100% - 2.5rem);

  padding: 1.5rem;
  z-index: 999;

  @include sm-down  {
    flex-direction: column;
    max-width: 25rem;
    padding: 0.75rem;
  }

  .accept-cookies__text {
    color: var(--color-grey-900);

    font-size: 1rem;
    line-height: 1.5rem;

    margin-bottom: 0;
    word-break: break-word;
  }

  .accept-cookies__buttons {
    display: flex;
    gap: 0.625rem;
    grid-template-columns: 6.56rem 6.25rem;

    @include sm-down {
      grid-template-columns: repeat(2, calc(50% - 0.31rem));
    }
  }

  .accept-cookies__btn {
    height: 2.25rem;
    width: 100%;
  }
}
</style>